// src/components/ui/Badge.js
import React from 'react';
import './ui.css';

const Badge = ({ 
  children, 
  variant = 'neutral', // Options: 'success', 'danger', 'neutral'
  className = '',
  showDot = false, 
  style = {} 
}) => {
  
  // High-Level Luxurious Color Mappings
  const variantStyles = {
    success: {
      background: 'linear-gradient(135deg, #D1FAE5, #A7F3D0)',
      color: '#047857',
      border: '1px solid rgba(16, 185, 129, 0.2)'
    },
    danger: {
      background: 'linear-gradient(135deg, #FEE2E2, #FCA5A5)',
      color: '#DC2626',
      border: '1px solid rgba(220, 38, 38, 0.2)'
    },
    neutral: {
      background: 'rgba(241, 245, 249, 0.8)',
      color: '#475569',
      border: '1px solid #E2E8F0'
    }
  };

  return (
    <span 
      className={`ui-badge ${className}`} 
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '5px 12px',
        borderRadius: '100px',
        fontSize: '10px',
        fontWeight: '900',
        letterSpacing: '0.6px',
        textTransform: 'uppercase',
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.02)',
        transition: 'all 0.2s ease',
        ...variantStyles[variant],
        ...style
      }}
    >
      {showDot && (
        <span style={{ 
          width: '6px', 
          height: '6px', 
          borderRadius: '50%', 
          background: 'currentColor', 
          boxShadow: '0 0 8px currentColor',
          animation: 'pulseGlow 2s infinite'
        }}></span>
      )}
      {children}
    </span>
  );
};

export default Badge;